module.exports = __webpack_public_path__ + "assets/images/project/menu/india-thumb.jpg?v=1d4d6c85";